// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.warning-display {
  background-color: #ffff88;
  border-radius: var(--dialog-border-radius);
  padding: var(--input-element-gap);
  display: flex;
  flex-direction: column;
  gap: var(--input-element-gap);
}

.warning-display-caption {
  color: var(--warn-color);
  display: flex;
  flex-direction: row;
  gap: var(--input-element-gap);
  justify-content: flex-start;
  align-items: center;
  font-size: var(--font-size-l);

  > button {
    color: var(--text-color);
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/warning-display/WarningDisplay.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;EAC3B,mBAAmB;EACnB,6BAA6B;;EAE7B;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".warning-display {\n  background-color: #ffff88;\n  border-radius: var(--dialog-border-radius);\n  padding: var(--input-element-gap);\n  display: flex;\n  flex-direction: column;\n  gap: var(--input-element-gap);\n}\n\n.warning-display-caption {\n  color: var(--warn-color);\n  display: flex;\n  flex-direction: row;\n  gap: var(--input-element-gap);\n  justify-content: flex-start;\n  align-items: center;\n  font-size: var(--font-size-l);\n\n  > button {\n    color: var(--text-color);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
